/* eslint-disable @next/next/no-img-element */
import NextImage from "next/image";

import { BackgroundWrap, GradientWrap, Wrapper, Cursive, TextBold } from "~/ui";

import { CurveArticle } from "../../ui/curveArticle";

interface NutritionArticleProps {
  article: any;
}

export const BlogArticle = (props: NutritionArticleProps) => {
  const { article } = props;
  const {
    acf: { title, content, image, author },
  } = article;

  return (
    <div className="bg-colorFifteen">
      <CurveArticle className="h-full w-full">
        <BackgroundWrap
          className="sliderimg bg-colorSixteen"
          style={{
            backgroundImage: `url(${
              image || "/assets/images/product-image-placeholder.svg"
            })`,
          }}
        >
          <GradientWrap className="flex h-full justify-start from-colorSixteen via-colorSixteen/80 to-transparent md:w-[80%] lg:w-[70%] lg:via-colorSixteen">
            <div className="m-auto w-[80%]">
              <Cursive className="text-colorEight">Tucker Tub Blog</Cursive>
              <h1
                className={`w-full text-base lg:w-3/5 font-tucker-tub text-xl font-bold uppercase text-colorFifteen lg:text-sliderTitle`}
              >
                {title}
              </h1>
              <div className="text-colorFourteen">- {author}</div>
            </div>
          </GradientWrap>
        </BackgroundWrap>
      </CurveArticle>
      <Wrapper>
        <div className="block space-y-10 pt-16 pb-10 lg:flex lg:space-x-10 lg:space-y-0">
          <div className="text-colorFourteen">
            <div
              className="prose-lg"
              dangerouslySetInnerHTML={{
                __html: content,
              }}
            />
          </div>
        </div>
      </Wrapper>
    </div>
  );
};
